module.exports = __webpack_public_path__ + "img/plants-green.9c5a3c01.png";